import { mapState } from 'vuex';
import { cloudFunctions, webPushId } from '../config';
import { db } from '../db';

export default {
  name: 'push-notifications-mixin',

  computed: {
    ...mapState(['user_data', 'userType', 'bindedUserData', 'askForPushPermition']),
  },

  methods: {
    updateUserAccount(data) {
      db.collection(this.userType).doc(this.user_data.id).update(data);
    },

    checkSafariPushNoifications(val = null) {
      if (this.iOS() && this.$messaging) {
        this.$store.state.askForPushPermition = true;
      } else {
        console.log('PUSH: not iOS or not supported');
      }
    },

    // requestSafariPersission() {
    //   console.log('PUSH: call request safari permission');
    //   this.messagingRegister();
    // },

    timeStamp() {
      const now = new Date();
      const time = [now.getHours(), now.getMinutes(), now.getSeconds()];

      for (let i = 1; i < 3; i++) {
        if (time[i] < 10) {
          time[i] = `0${time[i]}`;
        }
      }

      return `<i>${time.join(':')}</i> `;
    },

    messagingInit() {
      this.$messaging.onTokenRefresh(() => {
        this.$messaging.getToken().then((refreshedToken) => {
          console.log('PUSH: Token refreshed.');
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
        });
      });
    },

    messagingRegister(val = null) {
      return this.$messaging
        .requestPermission()
        .then(() => {
          console.log('PUSH: Notification permission granted.');
          this.messagingGetToken();
        })
        .catch((err) => {
          console.log('PUSH: Unable to get permission to notify.', err);
          this.$store.state.pushNotificationsAllowedInBrowser = false;

          this.updateUserAccount({
            messagingPush: false,
            messagingPushChat: false,
            messagingPushMatch: false,
            messagingPushConnection: false,
          });

          if (val) {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Um Push-Message zu aktivieren, gehe bitte in die Einstellungen deines Browsers.',
            });
          }
          return false;
        });
    },

    messagingGetToken() {
      // if (!this.user_data.messagingToken) {
      this.$messaging
        .getToken()
        .then((currentToken) => {
          console.log('PUSH: getToken ', currentToken);
          if (currentToken) {
            this.sendTokenToServer(currentToken);
          } else {
            console.log(
              'PUSH: No Instance ID token available. Request permission to generate one.',
            );
            // Show permission UI.
            this.setTokenSentToServer(false);
          }
        })
        .catch((err) => {
          console.log('PUSH: An error occurred while retrieving token. ', err);
          this.setTokenSentToServer(false);
        });
      // }
    },
    async sendTokenToServer(token, type = null) {
      console.log('PUSH: ', token);

      const data = {
        messagingToken: null,
        safariToken: null,
        messagingPush: true,
      };

      if (type === 'safari') {
        data.safariToken = token;
      } else {
        data.messagingToken = token;
      }

      await this.setDefaultMessagingSettings(this.user_data, data, true);
    },

    setTokenSentToServer(type) {
      // always leave token, to send or not will be checked on messagingPushXXXX variables in userData
      // if (type) return;
      // db.collection(this.userType)
      //   .doc(this.user_data.id)
      //   .update({
      //     messagingToken: null,
      //     safariToken: null,
      //   });
    },

    async setDefaultMessagingSettings(
      userData,
      pushSettings = null,
      pushAllowed = false,
    ) {
      let defaultMessagingSettings = {};
      if (userData.messagingEmailChat === undefined) {
        defaultMessagingSettings.messagingEmailChat = true;
      }
      if (userData.messagingEmailMatch === undefined) {
        defaultMessagingSettings.messagingEmailMatch = true;
      }
      if (userData.messagingEmailConnection === undefined) {
        defaultMessagingSettings.messagingEmailConnection = true;
      }

      if (pushAllowed) {
        defaultMessagingSettings.messagingPushChat = true;
        defaultMessagingSettings.messagingPushMatch = true;
        defaultMessagingSettings.messagingPushConnection = true;
      }

      console.log('PUSH: setDefaultMessaging', { userData });

      if (pushSettings) {
        defaultMessagingSettings = {
          ...defaultMessagingSettings,
          ...pushSettings,
        };
      }

      if (JSON.stringify(defaultMessagingSettings) !== '{}') {
        await db
          .collection(this.userType)
          .doc(this.user_data.id)
          .update(defaultMessagingSettings);
      }
    },

    iOS() {
      return (
        [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      );
    },
  },
};
